import styled from "styled-components";
import { Modal } from "components/Modal";

export const BrokerModalContainer = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;

  .modal-dialog {
    max-width: 454px;
    width: 100%;
    height: auto;
    max-height: 90vh;
    margin: auto;

    .modal-content {
      display: flex;
      flex-direction: column;
      height: 100%;
      max-height: 90vh;
      overflow: hidden;
      padding: 12px 20px 30px 20px;

      .modal-header {
        flex-shrink: 0;
        padding: 0;
        .body-heading {
          margin: 0;
          font-weight: 500;
          font-size: 20px;
          color: ${({ theme }) => theme.card.font.tertiary};
          text-align: center;
          width: 100%;
        }
      }

      .modal-body {
        flex: 1;
        overflow-y: auto;
        padding: 0;
        .portfolio-loader {
          margin-top: 70px;
        }
      }
    }
  }

  .modal-header .broker-modal-heading {
    margin: 0 auto;
  }

  @media (max-width: 630px) {
    .modal-dialog {
      max-width: 100%;
      max-height: 95vh;
      .modal-content .modal-header .body-heading {
        margin-right: 25px;
      }
    }
  }

  @media (max-width: 500px) {
    .modal-content .modal-header .body-heading {
      font-size: 16px;
    }
  }
`;
